<ng-container *ngFor="let item of data; index as i; trackBy: trackByTreeViewItemId">
    <app-dashboard-sources-list-item [item]="item" [sourcesProvider]="sourcesProvider"
                                     [depth]="depth" [filterTerm]="filterTerm" [recordCls]="recordCls"
                                     (selectionChange)="selectionChange.emit($event)"></app-dashboard-sources-list-item>
</ng-container>